import { render, staticRenderFns } from "./film-intercontrol.vue?vue&type=template&id=5cd0f5b4&"
import script from "./film-intercontrol.vue?vue&type=script&lang=js&"
export * from "./film-intercontrol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports